import { gql } from '@apollo/client'

export const PAYMENT_HISTORY_ATTRIBUTES = gql`
  fragment paymentHistoryAttributes on PaymentHistory {
    _id
    store_id
    bill_id
    bill_number
    bill_total
    current_paid
    customer_id
    customer_name
    customer_phone
    payment_method
    total_paid
    unpaid_amount
    created_date
  }
`

export const UPDATE_PAYMENT_HISTORIES = gql`
  mutation ($input: UpdatePaymentHistoriesInput) {
    updatePaymentHistories(input: $input) {
      status
      message
    }
  }
`